import { auth } from "./auth";

/** A route that needs a signed-in person, with this app's spinner while they're sent to sign in. */
export const AuthGuard = auth.AuthGuard;
